import LandPage from '../pages/LandPage'
import Dashboard from '../pages/Dashboard'
import StudyGame from '../pages/StudyGame'
import SocialHub from '../pages/community/SocialHub'
import AllUsersList from '../pages/community/AllUsersList'
import Profile from '../pages/community/Profile'
import Travel from '../pages/Travel'
import TravelAlbum from '../pages/TravelAlbum'
import TravelDestiny from '../pages/TravelDestiny'
import TravelNarrative from '../pages/TravelNarrative'
import Achievements from '../pages/Achievements'
import Login from '../pages/auth/Login'
import Register from '../pages/auth/Register'
import RecoverPassword from '../pages/auth/RecoverPassword'
import Inventory from '../pages/inventory/Inventory'
import Bag from '../pages/inventory/Bag'
import Hats from '../pages/inventory/Hats'
import Advices from '../pages/community/Advices'
import Help from '../pages/Help'

const miscellaneousRoutes = [
    { path: "/", name: "Landpage", isPrivate: false, Component: LandPage },
    { path: "/dashboard", name: "Início", isPrivate: true, Component: Dashboard },
    { path: "/ajuda", name: "Ajuda", isPrivate: true, Component: Help },
]

const gameRoutes = [
    { path: "/viajar", name: "Viajar", isPrivate: true, Component: Travel },
    { path: "/viajar/:paisId", name: "Destino de Viagem", isPrivate: true, Component: TravelDestiny },
    { path: "/viajar/:paisId/:viagemId", name: "Narrativa da Viagem", isPrivate: true, Component: TravelNarrative },
    { path: "/mundo-em-noticias", name: "Mundo em Notícias", isPrivate: true, Component: StudyGame },
]

const communityRoutes = [
    { path: "/comunidade", name: "Comunidade", isPrivate: true, Component: SocialHub },
    { path: "/comunidade/lista-de-utilizadores", name: "Utilizadores", isPrivate: true, Component: AllUsersList },
    { path: "/comunidade/conselhos", name: "Proezas", isPrivate: true, Component: Advices },
    { path: "/comunidade/perfil/:user", name: "Perfil do Utilizador", isPrivate: true, Component: Profile },
    { path: "/comunidade/perfil/:user/caderneta-de-viagens", name: "Caderneta de Viagens", isPrivate: true, Component: TravelAlbum },
    { path: "/comunidade/perfil/:user/itens", name: "Inventário", isPrivate: true, Component: Inventory },
    { path: "/comunidade/perfil/:user/itens/mochila", name: "Mochila", isPrivate: true, Component: Bag },
    { path: "/comunidade/perfil/:user/itens/chapeus", name: "Roupa", isPrivate: true, Component: Hats },
    { path: "/comunidade/perfil/:user/proezas", name: "Proezas", isPrivate: true, Component: Achievements },
]

const authRoutes = [
    { path: "/login", name: "Login", isPrivate: false, Component: Login },
    { path: "/registo", name: "Registo", isPrivate: false, Component: Register },
    { path: "/recuperar-password", name: "Recuperação da palavra-passe", isPrivate: false, Component: RecoverPassword },
]

const allRoutes = miscellaneousRoutes.concat(gameRoutes, communityRoutes, authRoutes)

export default allRoutes